<template>
  <div class="AccesoFeeds mb-8">
    <header class="flex justify-between items-center mb-1">
      <h1 class="text-gray-700">{{ totalFeeds }} feeds</h1>
      <lm-dropdown
        icon="sort"
        :items="orderOptions"
        :selected-item="selectedOrder"
        auto-close
        @select="onSelectOrder"
      />
    </header>
    <ul class="border-t">
      <li
        v-for="(item, index) in orderedFeeds"
        :key="index"
        class="p-4 border-b cursor-pointer hover:bg-gray-200"
        :class="{'bg-gray-200': selectedFeed === item.source}"
        @click="onFeedSelected(item)"
      >
        <span class="block text-s text-gray-900">{{ item.title }}</span>
        <span class="block mt-2 mb-0 text-xs text-gray-700">{{
          item.lastUpdatedAt | dateFromNow
        }}</span>
      </li>
    </ul>
    <span
      v-if="error"
      class="flex items-center mt-3 pt-1 text-error text-xs border-t border-error"
    >
      Please select a feed
    </span>
  </div>
</template>

<script>
import {orderBy} from 'lodash'
import LmDropdown from '@/components/ui/LmDropdown'
import {orderOptions} from '@/lib/sortOptions'

export default {
  name: 'AccesoFeeds',
  components: {LmDropdown},
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      error: false,
      orderedFeeds: [],
      selectedFeed: null,
      selectedOrder: null,
      orderOptions: orderOptions(['title', 'recent'], '')
    }
  },
  computed: {
    totalFeeds() {
      return this.list ? this.list.length : '0'
    }
  },
  watch: {
    list() {
      this.sortFeeds()
    }
  },
  mounted() {
    this.selectedOrder = this.orderOptions[0]
    this.sortFeeds()
  },
  methods: {
    onSelectOrder(item) {
      this.selectedOrder = item
      this.sortFeeds()
    },
    sortFeeds() {
      if (this.list) {
        const sorter = this.selectedOrder
        this.orderedFeeds = orderBy(this.list, sorter.field, sorter.order)
      }
    },
    onFeedSelected(item) {
      this.error = false
      this.selectedFeed = item.source
      this.$emit('feed-selected', item)
    },
    // PUBLIC
    reset() {
      this.error = false
      this.selectedFeed = null
    }
  }
}
</script>
